import { AppConfig } from '@ltvco/refresh-lib/ctx';
import { useQuery } from '@ltvco/refresh-lib/vendors';
import { useContext } from 'react';

import { cpscRecalls } from '../api';

import { CPSC_RECALLS_QUERY_KEY_PREFIX } from './constants';

import type { CpscRecallParams, CpscRecallRecord } from '../interfaces';

export const useCpscRecalls = (
  params?: CpscRecallParams | null,
  options?: { enabled?: boolean }
) => {
  const { logError } = useContext(AppConfig);
  const enabled = options?.enabled !== false;

  return useQuery<CpscRecallRecord[]>(
    [CPSC_RECALLS_QUERY_KEY_PREFIX, params ?? null],
    () => cpscRecalls.fetchRecalls(params ?? undefined),
    {
      enabled,
      refetchOnWindowFocus: false,
      onError: (error: unknown) => {
        logError(`${CPSC_RECALLS_QUERY_KEY_PREFIX} failed`, error as Error);
      },
    }
  );
};
